import { Divider } from '@byecode/ui'
import { RIGHT_ASIDE_CLASS, useAtomData } from '@lighthouse/shared'
import type { ScrollAreaProps } from '@mantine/core'
import { ScrollArea } from '@mantine/core'
import React, { useCallback, useMemo } from 'react'
import styled from 'styled-components'

import { lastPageOfStackAtom, pageInternalStateAtomFamily } from '@/atoms/page/state'
import { AsideType } from '@/atoms/page/types'

import { BlockSettingsController } from './BlockSettingController'
import { NavbarSettingController } from './NavbarSettingController'
import { PageBreadcrumbs } from './PageBreadcrumbs'
import { PageSettingController } from './PageSettingController'

const AsideScrollArea: (props: ScrollAreaProps) => React.ReactElement = styled(ScrollArea)`
    position: relative;
    flex: 0 0 349px;
    width: 349px;
    border-left: 1px solid var(--color-gray-200);
    background-color: #fff;

    > .mantine-ScrollArea-viewport > div {
        display: block !important;
        height: 100%;
    }
`

export const SettingAside = () => {
    const stackId = useAtomData(
        lastPageOfStackAtom,
        useCallback(s => s?.stackId ?? '', [])
    )
    const asideType = useAtomData(
        pageInternalStateAtomFamily(stackId),
        useCallback(s => s.asideType, [])
    )

    const content = useMemo(() => {
        switch (asideType) {
            case AsideType.NAVBAR: {
                return <NavbarSettingController />
            }

            case AsideType.BLOCK: {
                return <BlockSettingsController />
            }

            default: {
                return <PageSettingController />
            }
        }
    }, [asideType])

    return (
        <AsideScrollArea
            data-ignore-click-away
            className={RIGHT_ASIDE_CLASS}
            scrollHideDelay={0}
            onClick={(e: React.MouseEvent<HTMLDivElement>) => {
                e.stopPropagation()
            }}
        >
            {/* <ErrorBoundary fallbackRender={ErrorFallback}> */}
            <div style={{ paddingBottom: 100, boxSizing: 'border-box' }}>
                <PageBreadcrumbs />
                <Divider color="var(--color-gray-200)" />
                {content}
            </div>
            {/* </ErrorBoundary> */}
        </AsideScrollArea>
    )
}
